import {
  apiAuthenticateSession,
  apiFeatureFlags,
  apiGenerateSession,
  apiLog,
  apiLogin,
  apiSettings,
} from 'tsx/constants/api';
import { APPLICATION_TITLE } from 'tsx/constants/headerMenu';
import { get, post } from 'tsx/libs/genericAction';

import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'login';

export const setTitle = (title: string) => {
  document.title = `${title} - ${APPLICATION_TITLE}`;
};

const config = [
  { actionType: 'login', apiPath: apiLogin, method: post },
  { actionType: 'authenticate', apiPath: apiAuthenticateSession, method: post },
  { actionType: 'generateSession', apiPath: apiGenerateSession, method: get },
  {
    actionType: 'getFeatureFlag',
    apiPath: (params: Params) => `${apiFeatureFlags}/${params.flag}`,
    method: get,
  },
  {
    actionType: 'getFeatureFlags',
    apiPath: apiFeatureFlags,
    method: get,
  },
  { actionType: 'getSettings', apiPath: apiSettings, method: get },
  { actionType: 'log', apiPath: apiLog, method: post },
];

export const { login, authenticate, generateSession, getFeatureFlag, getFeatureFlags, getSettings, log } = createThunks(
  typePrefix,
  config,
);
